import { Navigate } from 'react-router-dom';
import { useFeatureAccess } from '@/features/authentication';
import { MASTER_DEFAULT_PATH, VISIBLE_MASTER_DEFINITIONS } from '../../constants/masters.constants';

/**
 * Where `/masters` lands: the first master this role may actually read.
 *
 * A fixed default sent everyone to Organization, so a role granted, say, Country and nothing else
 * clicked Master in their sidebar and was bounced to /unauthorized by a master they never asked for.
 * The order is the registry's, which is the order the sidebar lists them in, so the landing is the first
 * entry they can see. The masters the UI omits because the platform seeds them (Country, State and City)
 * are not candidates: landing on a screen that has no menu entry is a page the role cannot navigate back to.
 *
 * With nothing reachable it falls back to the declared default and that route's own guard refuses it --
 * one refusal, from the same source, rather than a second rule about emptiness here.
 *
 * Its own file because `routes.tsx` exports a route table rather than components, and react-refresh
 * needs the two kept apart.
 */
export function MastersLanding() {
  const { canReach } = useFeatureAccess();
  const first = VISIBLE_MASTER_DEFINITIONS.find((definition) => canReach(definition.feature));

  return <Navigate to={first?.path ?? MASTER_DEFAULT_PATH} replace />;
}
